import request from '@/utils/request'

let Meeting_reservationApi = {

  /*维修预约列表*/
  list(data) {
    return request._post('/shop/plus.meeting_reservation.Index/index', data);
},
/*添加维修预约*/
add(data) {
    return request._post('/shop/plus.meeting_reservation.Index/add', data);
},
/*修改维修预约*/
edit(data) {
    return request._post('/shop/plus.meeting_reservation.Index/edit', data);
},
/*删除维修预约*/
del(data) {
    return request._post('/shop/plus.meeting_reservation.Index/del', data);
},
/*维修预约详情*/
detail(data) {
  return request._post('/shop/plus.meeting_reservation.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.meeting_reservation.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.meeting_reservation.Setting/getSetting', data, errorback);
    },
}
export default Meeting_reservationApi;



// WEBPACK FOOTER //
// ./src/api/meeting_reservation.js